import React, { Children } from 'react'
import { Grid, Row, Separator, Subheading, useContainerWidth, H2 } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import { PillButton } from '../buttons'
import { FeatureCard } from '../card'
import ResponsiveSectionBand from '../ResponsiveSectionBand'

export default function CardPromos({ promoList, noActions }) {
  const [t] = useTranslation()
  const atWidth = useContainerWidth()
  const { title, items, description } = promoList
  const flavors = ['seafoam', 'mango']

  return items ? (
    <>
      <H2 centered>
        {title}
        {description && (
          <>
            <Separator size="xs" />
            <Subheading>{description}</Subheading>
          </>
        )}
      </H2>
      <Separator size="lg" />
      <ResponsiveSectionBand maxWidth="md">
        <Grid columns={12}>
          {Children.toArray(
            items.map((item, i) => {
              const actions = (
                <Row gutters="xs" alignY="middle" wrap>
                  {item.ctaText ? (
                    <div>
                      <PillButton
                        to={item.url}
                        linkName={`${title}: ${item.ctaText}`}
                        data-testid={`registration-cta-${item.url?.includes('online') ? 'online' : 'inperson'}`}
                      >
                        {item.ctaText}
                      </PillButton>
                    </div>
                  ) : null}
                  <PillButton
                    emphasis="low"
                    to={item.url?.includes('registration/online') ? '/registration/online' : '/registration/in-person'}
                    data-testid="registration-learn-more"
                  >
                    {t('common-ui:learn-more.action', 'Learn More')}
                  </PillButton>
                </Row>
              )
              return (
                <FeatureCard
                  columns={atWidth({ default: 12, md: 6 })}
                  flavor={flavors[i]}
                  actions={!noActions && actions}
                  {...item}
                />
              )
            })
          )}
        </Grid>
      </ResponsiveSectionBand>
    </>
  ) : null
}
